import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-danger'>404</h1>
            <h3 className='text-warning'>Page Not Found</h3>
        </div>
    );
};

export default NotFound;